<script setup>
const { t } = useI18n();

const earning = t('earning').replaceAll(
  '<strong>',
  '<strong class="section-earning__font section-earning__font--semi-bold">',
);

const { openContactModal } = useContactModal();

const { tp } = useTypograf();
</script>

<template>
  <section class="section-earning">
    <div class="container">
      <div class="section-earning__inner">
        <h2 class="section-earning__title">
          <img src="/icons/dollar.svg" alt="" class="section-earning__icon" />

          <span
            class="section-earning__font section-earning__font--title"
            v-html="tp(earning)"
          />
        </h2>

        <UiButton
          type="button"
          :text="$t('buttons.touch')"
          theme="purple"
          class="section-earning__button"
          @click="openContactModal"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.section-earning {
  $parent: &;
  $title-font-size: 50;
  $title-font-size-mobile: 20;

  &__inner {
    @include media-breakpoint-desktop {
      padding-block: 0;
      padding-inline: em(100);
    }
  }

  &__title {
    text-align: center;
    margin-bottom: em(77);
    position: relative;

    @include media-breakpoint-mobile {
      margin-bottom: em(39);
    }
  }

  &__font {
    &--title {
      font-size: em($title-font-size);
      line-height: em(61, $title-font-size);
      font-weight: $font-weight-light;

      @include media-breakpoint-mobile {
        font-size: em($title-font-size-mobile);
      }
    }

    :deep(#{$parent}__font--semi-bold) {
      font-weight: $font-weight-semi-bold;
    }
  }

  &__icon {
    display: inline;
    transform: translateY(em(5));
    margin-inline-end: em(11);

    @include box(em(45));

    @include media-breakpoint-mobile {
      transform: translateY(em(2));
      margin-inline-end: em(5);

      @include box(em(20));
    }
  }

  &__button {
    margin: 0 auto;
  }
}
</style>
